<template>
  <div>
    <div v-if="isFrameReady" class="footer before-use">
      <!-- 使用前の注意書き -->
      <MPMSFaceBeforeUseCaution
        v-if="
          masterSheet.content.description_json &&
          masterSheet.content.description_json.BeforeUseCaution
        "
        :note="masterSheet.content.description_json.BeforeUseCaution"
      />

      <div class="buttons">
        <!-- インターバル時間内であればカメラ起動はできない -->
        <FaceInIntervalButton v-if="isInIntervalFlag" />

        <div v-else>
          <!-- チケットを使うボタン -->
          <FaceStartButton
            :buttonLabel="
              isStampRally
                ? $t('MyTicketTicketing.UseStamp')
                : $t('MyTicketTicketing.UseTicket')
            "
            @clicked="isNotTargetVersion ? ncOpenCamera('emergencyCode') : ncOpenCamera('emergencyCode', masterBook.id)"
          />

          <!-- 開発ブラウザにて救済コード入力ページへのリンクボタン -->
          <a
            v-if="ENV == 'local'"
            class="emargency-botton"
            @click="goToEmergencyCode()"
          >
            <div class="title">
              {{ $t("MyTicketTicketing.entryThePasscode") }}
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, computed, watchEffect, ref } from "vue";

import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { useRouter } from "vue-router";

import myTicketsCommonService from "@/services/common/myTickets";
import { isAppVersionGreater } from "@/lib/compareVersion";

export default {
  name: "TheSheetLower",
  props: {
    isInIntervalFlag: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();

    const book = computed(() => store.getters["ticketing/book"]);
    const masterSheet = computed(() => store.getters["ticketing/masterSheet"]);
    const frame = computed(() => store.getters["ticketing/frame"]);
    const masterBook = computed(() => store.getters["ticketing/masterBook"]);
    const device = computed(() => store.getters["common/device"]);
    const appVersion = computed(() => store.getters["common/appVersion"]);
    const isNotTargetVersion = ref(false);

    const isFrameReady = ref(false);

    const isAvailablePeriod = computed(() => {
      if (book.value.user_started_at) {
        return myTicketsCommonService.checkIsAvailablePeriod(
          book.value.user_started_at,
          book.value.user_limited_at
        );
      } else {
        return myTicketsCommonService.checkIsAvailablePeriod(
          book.value.available_started_at,
          book.value.available_limited_at
        );
      }
    });

    const isStampRally = computed(() => {
      return (
        masterBook.value?.content?.description_json?.MbDisplayType ===
        "StampRally"
      );
    });

    // 救済コード入力画面へ
    const goToEmergencyCode = () => {
      // 複数枚の場合と1枚の場合で代入
      const sheetID = route.params.sheet_id.match(/,/)
        ? route.params.sheet_id.split(",")[0]
        : route.params.sheet_id;

      router.push({
        name: "SheetEmergencyCode",
        params: {
          book_group_id: route.params.book_group_id,
          sheet_id: sheetID,
          frame_id: String(frame.value.id),
        },
        query: { language: store.getters["common/lang"] },
      });
    };

    const checkVersion = () => {
      const targetVersions = {
        IOS: "2.8.8",
        ANDROID: "2.8.11",
      };

      const targetVersion = targetVersions[device.value];
      isNotTargetVersion.value = targetVersion
        ? !isAppVersionGreater(appVersion.value, targetVersion)
        : false;
    };

    onMounted(() => {
      console.log('ENV === "local" :>> ', process.env.NODE_ENV === "local");
      // ↓↓↓↓↓ローカルでの開発用仕様↓↓↓↓↓
      // QR読み込みを擬似的にできる仕様
      if (
        process.env.NODE_ENV === "local" &&
        route.query.fnc &&
        !route.query.fromQR
      ) {
        // http://localhost:8080/#/my-tickets/ticketing/37302/sheet/48930?fnc=MTK&type=mamoru&master_book_id=224&master_sheet_id=220,221,222,226,227&mamoru_auth=0b35290526ac31b1f2fd0199e78fd319417cf17ab1304856ae92f3ec9bf779aa&location_id=1145
        window.jcSetQRCode(window.location.href.split("?")[1]);
      }
      // ↑↑↑↑↑ローカルでの開発用仕様↑↑↑↑
    });

    watchEffect(() => {
      if (!frame.value.stamped_at && isAvailablePeriod.value) {
        isFrameReady.value = true;
      }
    });

    watchEffect(() => {
      if (appVersion.value) {
        checkVersion();
      }
    });

    return {
      isFrameReady,
      isStampRally,
      masterSheet,
      masterBook,
      goToEmergencyCode,
      isNotTargetVersion,
    };
  },
};
</script>
